// extracted by mini-css-extract-plugin
export var screen1 = "style-module--screen1--aee4a";
export var screen1__btn = "style-module--screen1__btn--f7308";
export var screen1__descriptionEl = "style-module--screen1__description-el--95b39";
export var screen1__info = "style-module--screen1__info--b0708";
export var screen1__subtitle = "style-module--screen1__subtitle--a7a45";
export var screen1__title = "style-module--screen1__title--57bf8";